import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getForecastHistorySearch = createApi(`getForecastHistorySearchSlice`, "GET");

const getForecastHistorySearchSlice = createSlice({
  name: 'getForecastHistorySearchSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getForecastHistorySearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getForecastHistorySearch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getForecastHistorySearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getForecastHistorySearchSlice.reducer;
